import { render } from "./ContactUsManagement.vue?vue&type=template&id=c643e144&scoped=true"
import script from "./ContactUsManagement.vue?vue&type=script&lang=js"
export * from "./ContactUsManagement.vue?vue&type=script&lang=js"

import "./ContactUsManagement.vue?vue&type=style&index=0&id=c643e144&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c643e144"]])

export default __exports__